"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.api = void 0;
var urls_1 = require("./urls");
var $ = require("jquery");
var ApiNode = (function () {
    function ApiNode(apiRoot) {
        this.root = apiRoot;
    }
    return ApiNode;
}());
var CollectionNode = (function (_super) {
    __extends(CollectionNode, _super);
    function CollectionNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionNode.prototype.options = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax(_this.getUrl(), {
                type: "OPTIONS",
            })
                .fail(_this.root.getErrorHandler(resolve, reject))
                .done(function (data) {
                resolve(data.actions.POST);
            });
        });
    };
    CollectionNode.prototype.get = function (data, errorCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax(_this.getUrl(), {
                type: "GET",
                data: data,
                contentType: "application/json"
            })
                .fail(_this.root.getErrorHandler(resolve, reject, errorCallback))
                .done(function (data) {
                resolve(data);
            });
        });
    };
    CollectionNode.prototype.post = function (data, errorCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax(_this.getUrl(), {
                type: "POST",
                data: JSON.stringify(data),
                contentType: "application/json",
            })
                .fail(_this.root.getErrorHandler(resolve, reject, errorCallback))
                .done(function (data, textStatus, jqXHR) {
                resolve(data);
            });
        });
    };
    return CollectionNode;
}(ApiNode));
var PaginatedCollectionNode = (function (_super) {
    __extends(PaginatedCollectionNode, _super);
    function PaginatedCollectionNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaginatedCollectionNode.prototype.options = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax(_this.getUrl(), {
                type: "OPTIONS",
            })
                .fail(_this.root.getErrorHandler(resolve, reject))
                .done(function (data) {
                resolve(data.actions.POST);
            });
        });
    };
    PaginatedCollectionNode.prototype.get = function (data, errorCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax(_this.getUrl(), {
                type: "GET",
                data: data,
                contentType: "application/json"
            })
                .fail(_this.root.getErrorHandler(resolve, reject, errorCallback))
                .done(function (data) {
                resolve(data);
            });
        });
    };
    PaginatedCollectionNode.prototype.getAll = function (data, errorCallback) {
        var filter = data || { page_size: 0 };
        filter.page_size = 0;
        return this.get(filter, errorCallback);
    };
    PaginatedCollectionNode.prototype.post = function (data, errorCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax(_this.getUrl(), {
                type: "POST",
                data: JSON.stringify(data),
                contentType: "application/json"
            })
                .fail(_this.root.getErrorHandler(resolve, reject, errorCallback))
                .done(function (data, textStatus, jqXHR) {
                resolve(data);
            });
        });
    };
    return PaginatedCollectionNode;
}(ApiNode));
var SingletonNode = (function (_super) {
    __extends(SingletonNode, _super);
    function SingletonNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingletonNode.prototype.options = function (errorCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax(_this.getUrl(), {
                type: "OPTIONS",
            })
                .fail(_this.root.getErrorHandler(resolve, reject, errorCallback))
                .done(function (data, textStatus, jqXHR) {
                resolve(data.actions.PUT);
            });
        });
    };
    SingletonNode.prototype.get = function (data, errorCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax(_this.getUrl(), {
                type: "GET",
                data: data,
                contentType: "application/json"
            })
                .fail(_this.root.getErrorHandler(resolve, reject, errorCallback))
                .done(function (data, textStatus, jqXHR) {
                resolve(data);
            });
        });
    };
    SingletonNode.prototype.put = function (data, errorCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax(_this.getUrl(), {
                type: "PUT",
                data: JSON.stringify(data),
                contentType: "application/json"
            })
                .fail(_this.root.getErrorHandler(resolve, reject, errorCallback))
                .done(function (data, textStatus, jqXHR) {
                resolve(data);
            });
        });
    };
    SingletonNode.prototype.delete_ = function (errorCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax(_this.getUrl(), {
                type: "DELETE",
                contentType: "application/json"
            })
                .fail(_this.root.getErrorHandler(resolve, reject, errorCallback))
                .done(function (data, textStatus, jqXHR) {
                resolve(null);
            });
        });
    };
    return SingletonNode;
}(ApiNode));
var PutableCollectionNode = (function (_super) {
    __extends(PutableCollectionNode, _super);
    function PutableCollectionNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PutableCollectionNode.prototype.put = function (data, errorCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax(_this.getUrl(), {
                type: "PUT",
                data: JSON.stringify(data),
                contentType: "application/json"
            })
                .fail(_this.root.getErrorHandler(resolve, reject, errorCallback))
                .done(function (data, textStatus, jqXHR) {
                resolve(data);
            });
        });
    };
    return PutableCollectionNode;
}(PaginatedCollectionNode));
var ObjectNode = (function (_super) {
    __extends(ObjectNode, _super);
    function ObjectNode(apiRoot, id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.id_ = id;
        return _this;
    }
    return ObjectNode;
}(SingletonNode));
var API = (function () {
    function API() {
        this.projects = new ProjectsAPI(this);
        this.users = new UsersAPI(this);
        this.reporting = new ReportingAPI(this);
    }
    API.prototype.apiErrorHandler = function (jqXHR, textStatus, errorThrown) {
        if (!jqXHR || jqXHR.status === 0)
            return;
        var errors;
        try {
            errors = JSON.parse(jqXHR.responseText);
        }
        catch (e) {
            console.warn("Not valid JSON: ", jqXHR.responseText);
            notification(gettext("There was an error on the server." +
                " Please contact SafetyEngine support on support@safety-engine.com" +
                " if the problem persists"), { 'type': 'error' });
            return;
        }
        if (errors.detail) {
            notification(gettext("UI Error") + ": " + errors.detail, {
                type: "error",
            });
        }
        else {
            handleFieldErrors(errors);
        }
    };
    API.prototype.getErrorHandler = function (resolve, reject, errorCallback) {
        var _this = this;
        if (errorCallback) {
            return function (jqXHR, textStatus, errorThrown) {
                var handled = errorCallback(jqXHR.status);
                if (!handled) {
                    _this.apiErrorHandler(jqXHR, textStatus, errorThrown);
                    reject(null);
                }
                resolve(null);
            };
        }
        return function (jqXHR, textStatus, errorThrown) {
            _this.apiErrorHandler(jqXHR, textStatus, errorThrown);
            reject(null);
        };
    };
    return API;
}());
var ProjectsAPI = (function (_super) {
    __extends(ProjectsAPI, _super);
    function ProjectsAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProjectsAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_list);
    };
    ProjectsAPI.prototype.id = function (x) {
        return new ProjectAPI(this.root, x);
    };
    return ProjectsAPI;
}(PaginatedCollectionNode));
var UsersAPI = (function (_super) {
    __extends(UsersAPI, _super);
    function UsersAPI(apiRoot, project_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        return _this;
    }
    UsersAPI.prototype.getUrl = function () {
        if (this.project_id) {
            return (0, urls_1.resolve)(urls_1.Urls.api_project_user_list, this.project_id);
        }
        else {
            throw new Error('404 not found.');
        }
    };
    UsersAPI.prototype.id = function (x) {
        throw new Error('Method not implemented');
    };
    UsersAPI.prototype.me = function () {
        return new MeAPI(this.root);
    };
    return UsersAPI;
}(PaginatedCollectionNode));
var ReportingAPI = (function (_super) {
    __extends(ReportingAPI, _super);
    function ReportingAPI(apiRoot) {
        var _this = _super.call(this, apiRoot) || this;
        _this.ownership = new OverviewOwnershipAPI(apiRoot);
        _this.statuses = new OverviewStatusesAPI(apiRoot);
        _this.todos = new OverviewTodosAPI(apiRoot);
        _this.barplots = new OverviewBarPlotsAPI(apiRoot);
        _this.valueatrisks = new OverviewValueAtRisksAPI(apiRoot);
        _this.matrices = new OverviewMatricesAPI(apiRoot);
        _this.tags = new OverviewTagsAPI(apiRoot);
        _this.simulation = new OverviewSimulationAPI(apiRoot);
        return _this;
    }
    ReportingAPI.prototype.getUrl = function () {
        throw new Error('Method not implemented.');
    };
    ReportingAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return ReportingAPI;
}(CollectionNode));
var OverviewStatusesAPI = (function (_super) {
    __extends(OverviewStatusesAPI, _super);
    function OverviewStatusesAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewStatusesAPI.prototype.getUrl = function () {
        return urls_1.Urls.overview_status_count;
    };
    OverviewStatusesAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return OverviewStatusesAPI;
}(CollectionNode));
var OverviewTodosAPI = (function (_super) {
    __extends(OverviewTodosAPI, _super);
    function OverviewTodosAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewTodosAPI.prototype.getUrl = function () {
        return urls_1.Urls.overview_status_todo;
    };
    OverviewTodosAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return OverviewTodosAPI;
}(CollectionNode));
var OverviewBarPlotsAPI = (function (_super) {
    __extends(OverviewBarPlotsAPI, _super);
    function OverviewBarPlotsAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewBarPlotsAPI.prototype.getUrl = function () {
        return urls_1.Urls.overview_bar_plot;
    };
    OverviewBarPlotsAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return OverviewBarPlotsAPI;
}(CollectionNode));
var OverviewValueAtRisksAPI = (function (_super) {
    __extends(OverviewValueAtRisksAPI, _super);
    function OverviewValueAtRisksAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewValueAtRisksAPI.prototype.getUrl = function () {
        return urls_1.Urls.overview_value_at_risk;
    };
    OverviewValueAtRisksAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return OverviewValueAtRisksAPI;
}(CollectionNode));
var OverviewOwnershipAPI = (function (_super) {
    __extends(OverviewOwnershipAPI, _super);
    function OverviewOwnershipAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewOwnershipAPI.prototype.getUrl = function () {
        return urls_1.Urls.overview_ownership;
    };
    OverviewOwnershipAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return OverviewOwnershipAPI;
}(CollectionNode));
var OverviewMatricesAPI = (function (_super) {
    __extends(OverviewMatricesAPI, _super);
    function OverviewMatricesAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewMatricesAPI.prototype.getUrl = function () {
        return urls_1.Urls.overview_matrix;
    };
    OverviewMatricesAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return OverviewMatricesAPI;
}(CollectionNode));
var OverviewTagsAPI = (function (_super) {
    __extends(OverviewTagsAPI, _super);
    function OverviewTagsAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewTagsAPI.prototype.getUrl = function () {
        return urls_1.Urls.overview_tag;
    };
    OverviewTagsAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return OverviewTagsAPI;
}(CollectionNode));
var OverviewSimulationAPI = (function (_super) {
    __extends(OverviewSimulationAPI, _super);
    function OverviewSimulationAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewSimulationAPI.prototype.getUrl = function () {
        return urls_1.Urls.overview_simulation;
    };
    OverviewSimulationAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return OverviewSimulationAPI;
}(CollectionNode));
var MeAPI = (function (_super) {
    __extends(MeAPI, _super);
    function MeAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MeAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_user_list_me);
    };
    MeAPI.prototype.getPairUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_user_pair_2fa);
    };
    return MeAPI;
}(SingletonNode));
var ProjectAPI = (function (_super) {
    __extends(ProjectAPI, _super);
    function ProjectAPI(apiRoot, id) {
        var _this = _super.call(this, apiRoot, id) || this;
        _this.users = new UsersAPI(apiRoot, _this.id_);
        _this.risks = new RisksAPI(apiRoot, _this.id_);
        _this.controls = new ControlsAPI(apiRoot, _this.id_);
        _this.actions = new ActionsAPI(apiRoot, _this.id_);
        _this.categories = new CategoriesAPI(apiRoot, _this.id_);
        _this.cacategories = new CaCategoriesAPI(apiRoot, _this.id_);
        _this.tags = new CategoryTagsAPI(apiRoot, _this.id_);
        _this.catags = new CaCategoryTagsAPI(apiRoot, _this.id_);
        _this.quick_users = new QuickUserAPI(apiRoot, _this.id_);
        _this.roles = new RolesAPI(apiRoot, _this.id_);
        _this.causalities = new CausalitiesAPI(apiRoot, _this.id_);
        return _this;
    }
    ProjectAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_detail, this.id_);
    };
    return ProjectAPI;
}(ObjectNode));
var RisksAPI = (function (_super) {
    __extends(RisksAPI, _super);
    function RisksAPI(apiRoot, project_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        return _this;
    }
    RisksAPI.prototype.getUrl = function () {
        if (this.project_id) {
            return (0, urls_1.resolve)(urls_1.Urls.api_project_risk_list, this.project_id);
        }
        else {
            throw new Error('404 not found.');
        }
    };
    RisksAPI.prototype.id = function (x) {
        return new RiskAPI(this.root, x, this.project_id);
    };
    return RisksAPI;
}(PaginatedCollectionNode));
var RiskAPI = (function (_super) {
    __extends(RiskAPI, _super);
    function RiskAPI(apiRoot, id, project_id) {
        var _this = _super.call(this, apiRoot, id) || this;
        _this.project_id = project_id;
        _this.controls = new ControlsAPI(apiRoot, _this.project_id, _this.id_);
        _this.attachable_controls = new AttachableControlsAPI(apiRoot, _this.project_id, _this.id_);
        _this.riskcontrols = new RiskControlsAPI(apiRoot, _this.project_id, _this.id_);
        _this.references = new ReferencesAPI(apiRoot, _this.project_id, id, null);
        _this.causalities = new CausalitiesAPI(apiRoot, _this.project_id, id);
        _this.attachable_causalities = new AttachableCausalitiesAPI(apiRoot, _this.project_id, id);
        _this.riskreview = new RiskReviewAPI(apiRoot, _this.project_id, id);
        _this.exclusive_controls = new ExclusivelyAttachedControlsAPI(apiRoot, _this.project_id, id);
        return _this;
    }
    RiskAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_risk_detail, this.project_id, this.id_);
    };
    return RiskAPI;
}(ObjectNode));
var RiskReviewAPI = (function (_super) {
    __extends(RiskReviewAPI, _super);
    function RiskReviewAPI(apiRoot, project_id, risk_id) {
        var _this = _super.call(this, apiRoot, null) || this;
        _this.project_id = project_id;
        _this.risk_id = risk_id;
        return _this;
    }
    RiskReviewAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_risk_review_detail, this.project_id, this.risk_id);
    };
    return RiskReviewAPI;
}(ObjectNode));
var ControlsAPI = (function (_super) {
    __extends(ControlsAPI, _super);
    function ControlsAPI(apiRoot, project_id, risk_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.risk_id = risk_id;
        return _this;
    }
    ControlsAPI.prototype.getUrl = function () {
        if (this.risk_id) {
            return (0, urls_1.resolve)(urls_1.Urls.api_project_risk_control_list, this.project_id, this.risk_id);
        }
        else if (this.project_id) {
            return (0, urls_1.resolve)(urls_1.Urls.api_project_control_list, this.project_id);
        }
        else {
            throw new Error('404 not found.');
        }
    };
    ControlsAPI.prototype.id = function (x) {
        return new ControlAPI(this.root, x, this.project_id, this.risk_id);
    };
    return ControlsAPI;
}(PaginatedCollectionNode));
var ActionsAPI = (function (_super) {
    __extends(ActionsAPI, _super);
    function ActionsAPI(apiRoot, project_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        return _this;
    }
    ActionsAPI.prototype.getUrl = function () {
        if (this.project_id) {
            return (0, urls_1.resolve)(urls_1.Urls.api_project_action_list, this.project_id);
        }
        else {
            throw new Error('404 not found.');
        }
    };
    ActionsAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return ActionsAPI;
}(PaginatedCollectionNode));
var AttachableControlsAPI = (function (_super) {
    __extends(AttachableControlsAPI, _super);
    function AttachableControlsAPI(apiRoot, project_id, risk_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.risk_id = risk_id;
        return _this;
    }
    AttachableControlsAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    AttachableControlsAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_risk_attachable_controls_list, this.project_id, this.risk_id);
    };
    return AttachableControlsAPI;
}(PaginatedCollectionNode));
var ExclusivelyAttachedControlsAPI = (function (_super) {
    __extends(ExclusivelyAttachedControlsAPI, _super);
    function ExclusivelyAttachedControlsAPI(apiRoot, project_id, risk_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.risk_id = risk_id;
        return _this;
    }
    ExclusivelyAttachedControlsAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    ExclusivelyAttachedControlsAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.risk_exclusive_controls_list, this.project_id, this.risk_id);
    };
    return ExclusivelyAttachedControlsAPI;
}(PaginatedCollectionNode));
var RiskControlsAPI = (function (_super) {
    __extends(RiskControlsAPI, _super);
    function RiskControlsAPI(apiRoot, project_id, risk_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.risk_id = risk_id;
        return _this;
    }
    RiskControlsAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    RiskControlsAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_risk_riskcontrol_list, this.project_id, this.risk_id);
    };
    return RiskControlsAPI;
}(SingletonNode));
var ControlAPI = (function (_super) {
    __extends(ControlAPI, _super);
    function ControlAPI(apiRoot, id, project_id, risk_id) {
        var _this = _super.call(this, apiRoot, id) || this;
        _this.project_id = project_id;
        _this.risk_id = risk_id;
        _this.recurrence = new RecurrenceAPI(apiRoot, project_id, id);
        _this.tags = new CaCategoryTagsAPI(apiRoot, project_id, id);
        _this.comments = new ControlCommentsAPI(apiRoot, project_id, id);
        _this.relations = new ControlRisksAPI(apiRoot, project_id, id);
        _this.references = new ReferencesAPI(apiRoot, project_id, null, id);
        _this.entries = new ControlEntriesAPI(apiRoot, project_id, id);
        _this.attachableRisks = new AttachableRisksAPI(apiRoot, project_id, id);
        _this.controlCosts = new ControlCostsAPI(apiRoot, project_id, id);
        return _this;
    }
    ControlAPI.prototype.getUrl = function () {
        if (this.risk_id) {
            return (0, urls_1.resolve)(urls_1.Urls.api_project_risk_control_detail, this.project_id, this.risk_id, this.id_);
        }
        else {
            return (0, urls_1.resolve)(urls_1.Urls.api_project_control_detail, this.project_id, this.id_);
        }
    };
    return ControlAPI;
}(ObjectNode));
var RecurrenceAPI = (function (_super) {
    __extends(RecurrenceAPI, _super);
    function RecurrenceAPI(apiRoot, project_id, control_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.control_id = control_id;
        return _this;
    }
    RecurrenceAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_control_recurrence_detail, this.project_id, this.control_id);
    };
    return RecurrenceAPI;
}(SingletonNode));
var ControlCommentsAPI = (function (_super) {
    __extends(ControlCommentsAPI, _super);
    function ControlCommentsAPI(apiRoot, project_id, control_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.control_id = control_id;
        return _this;
    }
    ControlCommentsAPI.prototype.id = function (x) {
        return new ControlCommentAPI(this.root, x, this.project_id, this.control_id);
    };
    ControlCommentsAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_control_comment_list, this.project_id, this.control_id);
    };
    return ControlCommentsAPI;
}(PaginatedCollectionNode));
var ControlCommentAPI = (function (_super) {
    __extends(ControlCommentAPI, _super);
    function ControlCommentAPI(apiRoot, id, project_id, control_id) {
        var _this = _super.call(this, apiRoot, id) || this;
        _this.project_id = project_id;
        _this.control_id = control_id;
        return _this;
    }
    ControlCommentAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_control_comment_detail, this.project_id, this.control_id, this.id_);
    };
    return ControlCommentAPI;
}(ObjectNode));
var ControlCostsAPI = (function (_super) {
    __extends(ControlCostsAPI, _super);
    function ControlCostsAPI(apiRoot, project_id, control_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.control_id = control_id;
        return _this;
    }
    ControlCostsAPI.prototype.id = function (x) {
        return new ControlCostAPI(this.root, x, this.project_id, this.control_id);
    };
    ControlCostsAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_control_cost_list, this.project_id, this.control_id);
    };
    return ControlCostsAPI;
}(PaginatedCollectionNode));
var ControlCostAPI = (function (_super) {
    __extends(ControlCostAPI, _super);
    function ControlCostAPI(apiRoot, id, project_id, control_id) {
        var _this = _super.call(this, apiRoot, id) || this;
        _this.project_id = project_id;
        _this.control_id = control_id;
        return _this;
    }
    ControlCostAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_control_cost_detail, this.project_id, this.control_id, this.id_);
    };
    return ControlCostAPI;
}(ObjectNode));
var CaCategoryTagsAPI = (function (_super) {
    __extends(CaCategoryTagsAPI, _super);
    function CaCategoryTagsAPI(apiRoot, project_id, control_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.control_id = control_id;
        return _this;
    }
    CaCategoryTagsAPI.prototype.getUrl = function () {
        if (this.control_id) {
            return (0, urls_1.resolve)(urls_1.Urls.api_project_control_tags_list, this.project_id, this.control_id);
        }
        else {
            return (0, urls_1.resolve)(urls_1.Urls.api_project_catag_list, this.project_id);
        }
    };
    CaCategoryTagsAPI.prototype.id = function (x) {
        return new CaCategoryTagAPI(this.root, x, this.project_id);
    };
    return CaCategoryTagsAPI;
}(PutableCollectionNode));
var CaCategoryTagAPI = (function (_super) {
    __extends(CaCategoryTagAPI, _super);
    function CaCategoryTagAPI(apiRoot, id, project_id) {
        var _this = _super.call(this, apiRoot, id) || this;
        _this.project_id = project_id;
        return _this;
    }
    CaCategoryTagAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_catag_detail, this.project_id, this.id_);
    };
    return CaCategoryTagAPI;
}(ObjectNode));
var CategoryTagsAPI = (function (_super) {
    __extends(CategoryTagsAPI, _super);
    function CategoryTagsAPI(apiRoot, project_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        return _this;
    }
    CategoryTagsAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_tag_list, this.project_id);
    };
    CategoryTagsAPI.prototype.id = function (x) {
        return new CategoryTagAPI(this.root, x, this.project_id);
    };
    return CategoryTagsAPI;
}(PaginatedCollectionNode));
var CategoryTagAPI = (function (_super) {
    __extends(CategoryTagAPI, _super);
    function CategoryTagAPI(apiRoot, id, project_id) {
        var _this = _super.call(this, apiRoot, id) || this;
        _this.project_id = project_id;
        return _this;
    }
    CategoryTagAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_tag_detail, this.project_id, this.id_);
    };
    return CategoryTagAPI;
}(ObjectNode));
var CaCategoriesAPI = (function (_super) {
    __extends(CaCategoriesAPI, _super);
    function CaCategoriesAPI(apiRoot, project_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        return _this;
    }
    CaCategoriesAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_cacategory_list, this.project_id);
    };
    CaCategoriesAPI.prototype.id = function (x) {
        return new CaCategoryAPI(this.root, x, this.project_id);
    };
    return CaCategoriesAPI;
}(PaginatedCollectionNode));
var CaCategoryAPI = (function (_super) {
    __extends(CaCategoryAPI, _super);
    function CaCategoryAPI(apiRoot, id, project_id) {
        var _this = _super.call(this, apiRoot, id) || this;
        _this.project_id = project_id;
        return _this;
    }
    CaCategoryAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_cacategory_detail, this.project_id, this.id_);
    };
    return CaCategoryAPI;
}(ObjectNode));
var CategoriesAPI = (function (_super) {
    __extends(CategoriesAPI, _super);
    function CategoriesAPI(apiRoot, project_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        return _this;
    }
    CategoriesAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_category_list, this.project_id);
    };
    CategoriesAPI.prototype.id = function (x) {
        return new CategoryAPI(this.root, x, this.project_id);
    };
    return CategoriesAPI;
}(PaginatedCollectionNode));
var CategoryAPI = (function (_super) {
    __extends(CategoryAPI, _super);
    function CategoryAPI(apiRoot, id, project_id) {
        var _this = _super.call(this, apiRoot, id) || this;
        _this.project_id = project_id;
        return _this;
    }
    CategoryAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_category_detail, this.project_id, this.id_);
    };
    return CategoryAPI;
}(ObjectNode));
var ControlRisksAPI = (function (_super) {
    __extends(ControlRisksAPI, _super);
    function ControlRisksAPI(apiRoot, project_id, control_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.control_id = control_id;
        return _this;
    }
    ControlRisksAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_control_relation_list, this.project_id, this.control_id);
    };
    ControlRisksAPI.prototype.id = function (x) {
        return new ControlRiskAPI(this.root, x, this.project_id, this.control_id);
    };
    return ControlRisksAPI;
}(PaginatedCollectionNode));
var AttachableRisksAPI = (function (_super) {
    __extends(AttachableRisksAPI, _super);
    function AttachableRisksAPI(apiRoot, project_id, control_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.control_id = control_id;
        return _this;
    }
    AttachableRisksAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_control_attachable_risks_list, this.project_id, this.control_id);
    };
    AttachableRisksAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return AttachableRisksAPI;
}(PaginatedCollectionNode));
var ReferencesAPI = (function (_super) {
    __extends(ReferencesAPI, _super);
    function ReferencesAPI(apiRoot, project_id, risk_id, control_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.risk_id = risk_id;
        _this.control_id = control_id;
        return _this;
    }
    ReferencesAPI.prototype.getUrl = function () {
        if (this.risk_id)
            return (0, urls_1.resolve)(urls_1.Urls.api_project_risk_references_list, this.project_id, this.risk_id);
        else if (this.control_id)
            return (0, urls_1.resolve)(urls_1.Urls.api_project_control_references_list, this.project_id, this.control_id);
        else
            throw new Error("Unknown Reference end-point");
    };
    ReferencesAPI.prototype.id = function (x) {
        return new ReferenceAPI(this.root, x, this.project_id, this.risk_id, this.control_id);
    };
    return ReferencesAPI;
}(PaginatedCollectionNode));
var ReferenceAPI = (function (_super) {
    __extends(ReferenceAPI, _super);
    function ReferenceAPI(apiRoot, id, project_id, risk_id, control_id) {
        var _this = _super.call(this, apiRoot, id) || this;
        _this.project_id = project_id;
        _this.risk_id = risk_id;
        _this.control_id = control_id;
        return _this;
    }
    ReferenceAPI.prototype.getUrl = function () {
        if (this.risk_id)
            return (0, urls_1.resolve)(urls_1.Urls.api_project_risk_references_detail, this.project_id, this.risk_id, this.id_);
        else if (this.control_id)
            return (0, urls_1.resolve)(urls_1.Urls.api_project_control_references_detail, this.project_id, this.control_id, this.id_);
        else
            throw new Error("Unknown Reference end-point");
    };
    return ReferenceAPI;
}(ObjectNode));
var CausalitiesAPI = (function (_super) {
    __extends(CausalitiesAPI, _super);
    function CausalitiesAPI(apiRoot, project_id, risk_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.risk_id = risk_id;
        return _this;
    }
    CausalitiesAPI.prototype.getUrl = function () {
        if (this.risk_id) {
            return (0, urls_1.resolve)(urls_1.Urls.api_risk_causality_list, this.project_id, this.risk_id);
        }
        else {
            return (0, urls_1.resolve)(urls_1.Urls.api_project_causality_list, this.project_id);
        }
    };
    CausalitiesAPI.prototype.id = function (x) {
        return new CausalityAPI(this.root, x, this.project_id, this.risk_id);
    };
    return CausalitiesAPI;
}(PaginatedCollectionNode));
var AttachableCausalitiesAPI = (function (_super) {
    __extends(AttachableCausalitiesAPI, _super);
    function AttachableCausalitiesAPI(apiRoot, project_id, risk_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.risk_id = risk_id;
        return _this;
    }
    AttachableCausalitiesAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    AttachableCausalitiesAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_risk_attachable_causalities_list, this.project_id, this.risk_id);
    };
    return AttachableCausalitiesAPI;
}(PaginatedCollectionNode));
var CausalityAPI = (function (_super) {
    __extends(CausalityAPI, _super);
    function CausalityAPI(apiRoot, id, project_id, risk_id) {
        var _this = _super.call(this, apiRoot, id) || this;
        _this.project_id = project_id;
        _this.risk_id = risk_id;
        _this.affected_risks = new CauseAffectedRisksAPI(apiRoot, project_id, _this.id_);
        _this.attachable_risks = new CausalityAttachableRisksAPI(apiRoot, project_id, _this.id_);
        return _this;
    }
    CausalityAPI.prototype.getUrl = function () {
        if (this.risk_id) {
            return (0, urls_1.resolve)(urls_1.Urls.api_risk_causality_detail, this.project_id, this.risk_id, this.id_);
        }
        else {
            return (0, urls_1.resolve)(urls_1.Urls.api_project_causality_detail, this.project_id, this.id_);
        }
    };
    return CausalityAPI;
}(ObjectNode));
var CauseAffectedRisksAPI = (function (_super) {
    __extends(CauseAffectedRisksAPI, _super);
    function CauseAffectedRisksAPI(apiRoot, project_id, cause_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.cause_id = cause_id;
        return _this;
    }
    CauseAffectedRisksAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_causality_affected_risk_list, this.project_id, this.cause_id);
    };
    CauseAffectedRisksAPI.prototype.id = function (x) {
        throw new Error('Method not implemented');
    };
    return CauseAffectedRisksAPI;
}(PaginatedCollectionNode));
var CausalityAttachableRisksAPI = (function (_super) {
    __extends(CausalityAttachableRisksAPI, _super);
    function CausalityAttachableRisksAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CausalityAttachableRisksAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_causality_attachable_risks_list, this.project_id, this.cause_id);
    };
    return CausalityAttachableRisksAPI;
}(CauseAffectedRisksAPI));
var ControlRiskAPI = (function (_super) {
    __extends(ControlRiskAPI, _super);
    function ControlRiskAPI(apiRoot, id, project_id, control_id) {
        var _this = _super.call(this, apiRoot, id) || this;
        _this.project_id = project_id;
        _this.control_id = control_id;
        return _this;
    }
    ControlRiskAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_control_relation_detail, this.project_id, this.control_id, this.id_);
    };
    return ControlRiskAPI;
}(ObjectNode));
var ControlEntriesAPI = (function (_super) {
    __extends(ControlEntriesAPI, _super);
    function ControlEntriesAPI(apiRoot, project_id, control_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        _this.control_id = control_id;
        return _this;
    }
    ControlEntriesAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_control_entries_list, this.project_id, this.control_id);
    };
    ControlEntriesAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return ControlEntriesAPI;
}(PaginatedCollectionNode));
var QuickUserAPI = (function (_super) {
    __extends(QuickUserAPI, _super);
    function QuickUserAPI(apiRoot, project_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        return _this;
    }
    QuickUserAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_quick_user, this.project_id);
    };
    QuickUserAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return QuickUserAPI;
}(PaginatedCollectionNode));
var RolesAPI = (function (_super) {
    __extends(RolesAPI, _super);
    function RolesAPI(apiRoot, project_id) {
        var _this = _super.call(this, apiRoot) || this;
        _this.project_id = project_id;
        return _this;
    }
    RolesAPI.prototype.getUrl = function () {
        return (0, urls_1.resolve)(urls_1.Urls.api_project_roles_list, this.project_id);
    };
    RolesAPI.prototype.id = function (x) {
        throw new Error('Method not implemented.');
    };
    return RolesAPI;
}(PaginatedCollectionNode));
exports.api = new API();
